import(/* webpackMode: "eager" */ "/builds/bethematch/appdev/matchsync/formsengine/international-forms-automation/apps/ifa-app/src/app/[...dashboard]/page.tsx");
